import { useEffect, useState } from "react";
import GetTime from "../../utils/gettime";
import { API_STATUS } from "../../constants";
import { SaveLaterApi } from "../../apis/posts/save_later_api";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { EventLikeStatusApi } from "../../apis/event/event_like_status_api";
import { EventShareStatusApi } from "../../apis/event/event_share_status_api";
import { ArchiveEventApi } from "../../apis/event/archive_event_api";
import { DeleteEventApi } from "../../apis/event/delete_event_api";
import { RemoveLaterApi } from "../../apis/posts/remove_later_api";

export default function EventBoxHeader({ item, esave, setShowLike, setShowShare, setShowPost, showLike, showShare }) {
    const navigate = useNavigate();
    const [loginId, setLoginId] = useState("");
    const [saved, setSaved] = useState(0);
    const [saveApi, setSaveApi] = useState(API_STATUS);
    const [status, setStatus] = useState(1);

    useEffect(() => {
        const userCode = sessionStorage.getItem('USER_CODE');
        setLoginId(userCode);

        if (esave != null) {
            if (esave) {
                setSaved(1);
            }
        }

        setShowLike(item.e_view_like);
        setShowShare(item.e_view_share);
        setStatus(item.e_status);

    }, []);


    useEffect(() => {
        const userCode = sessionStorage.getItem('USER_CODE');
        setLoginId(userCode);
    }, []);

    return <div className="flex gap-3 sm:p-4 p-2.5 text-sm font-medium">

        <div className="flex-1">
            <a href={'/profile/' + item.u_token}> <h3 className="text-blue-400 dark:text-white"> {item.e_title} </h3> </a>
            <div className="text-xs text-gray-500 dark:text-white/80"> {GetTime(item.e_date)}</div>
        </div>

        <div className="-mr-1">
            <button type="button" className="button__ico w-8 h-8"> <ion-icon className="text-xl" name="ellipsis-horizontal"><i className="fa fa-ellipsis-h"></i></ion-icon> </button>
            <div className="w-[245px]" uk-dropdown="pos: bottom-right; animation: uk-animation-scale-up uk-transform-origin-top-right; animate-out: true; mode: click">

                {
                    item.u_token === loginId &&
                    <nav>
                        {
                            status === 1 &&
                            <Link
                                onClick={() => {
                                    setStatus(0);
                                    ArchiveEventApi({ 'status': 0, 'pid': item.e_id }, setSaveApi);
                                }} className="text-red-400 hover:!bg-red-50 dark:hover:!bg-red-500/50"> <ion-icon className="text-xl shrink-0" name="stop-circle-outline"></ion-icon>  Archive </Link>
                        }

                        {
                            status === 0 &&
                            <Link
                                onClick={() => {
                                    setStatus(1);
                                    ArchiveEventApi({ 'status': 1, 'pid': item.e_id }, setSaveApi);
                                }} className="text-red-400 hover:!bg-red-50 dark:hover:!bg-red-500/50"> <ion-icon className="text-xl shrink-0" name="stop-circle-outline"></ion-icon>  Unarchive </Link>
                        }

                        <Link
                            onClick={() => {
                                if (showLike == 1) {
                                    setShowLike(0);
                                    EventLikeStatusApi({ 'status': 0, 'pid': item.e_id }, setSaveApi);
                                } else {
                                    setShowLike(1);
                                    EventLikeStatusApi({ 'status': 1, 'pid': item.e_id }, setSaveApi);
                                }
                            }}
                        > <ion-icon className="text-xl shrink-0" name="notifications-off-outline"></ion-icon> {showLike === 1 ? 'Hide Like Count' : 'Show Like Count'} </Link>
                        <Link
                            onClick={() => {
                                if (showShare == 1) {
                                    setShowShare(0);
                                    EventShareStatusApi({ 'status': 0, 'pid': item.e_id }, setSaveApi);
                                } else {
                                    setShowShare(1);
                                    EventShareStatusApi({ 'status': 1, 'pid': item.e_id }, setSaveApi);
                                }
                            }}
                        > <ion-icon className="text-xl shrink-0" name="flag-outline"></ion-icon>  {showShare === 1 ? 'Hide Share Count' : 'Show Share Count'} </Link>


                        <NavLink
                            to="/edit_event"
                            state={{ 'item': item }}
                        > <ion-icon className="text-xl shrink-0" name="share-outline"></ion-icon>  Edit </NavLink>
                        <hr />
                        <Link
                            onClick={() => {
                                setShowPost(0);
                                DeleteEventApi({ 'status': 0, 'pid': item.e_id }, setSaveApi);
                            }} className="text-red-400 hover:!bg-red-50 dark:hover:!bg-red-500/50"> <ion-icon className="text-xl shrink-0" name="stop-circle-outline"></ion-icon>  Delete </Link>
                    </nav>
                }

                {
                    item.u_token !== loginId &&
                    <nav>
                        {
                            saved === 1 &&
                            <button
                                onClick={() => {
                                    RemoveLaterApi({ 'type': 'Event', 'id': item.e_id }, setSaveApi);
                                    setShowPost(0);
                                }}

                            > <ion-icon className="text-xl shrink-0" name="bookmark-outline"></ion-icon>Unsave </button>
                        }
                        {
                            saved === 0 &&
                            <button
                                onClick={() => {
                                    SaveLaterApi({ 'type': 'Event', 'id': item.e_id }, setSaveApi);
                                    setSaved(1);
                                }}
                            > <ion-icon className="text-xl shrink-0" name="bookmark-outline"></ion-icon>Save </button>
                        }

                    </nav>
                }
            </div>
        </div>
    </div>
}